module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MCA1MCI+CiAgPGRlZnM+CiAgICA8c3R5bGU+CiAgICAgIC5jbHMtMSB7CiAgICAgICAgZmlsbDogcmdiYSgwLCAwLCAwLCAwLjQpOwogICAgICB9CiAgICA8L3N0eWxlPgogIDwvZGVmcz4KICA8cmVjdCBpZD0iUmVjdGFuZ2xlXzciIGRhdGEtbmFtZT0iUmVjdGFuZ2xlIDciIGNsYXNzPSJjbHMtMSIgd2lkdGg9IjUwIiBoZWlnaHQ9IjUwIiByeD0iMTEiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/wl-black-off.svg
// module id = 4FPc
// module chunks = 1